import {credit as credit_init} from "./marika-m/credits";
import {init as animations_init} from "./marika-m/pageTransition";


const init_app = () => {
    credit_init();
    animations_init();
}

init_app();
